import React from "react";
import {StatusIndicatorsResponse} from "../../../../../services/oneButtonServices/opportunityValidationService";
import {Table} from "antd";
import {FaThumbsDown, FaThumbsUp} from "react-icons/fa";
import TextArea from "antd/es/input/TextArea";
import {renderStatusIcon} from "./OpportunityValidationShared";

interface StatusIndicatorsProps {
    statusIndicators: StatusIndicatorsResponse;
}

export const StatusIndicators: React.FC<StatusIndicatorsProps> = ({statusIndicators}) => {

    const overallStatus =
        statusIndicators.botRunStatusflag &&
        statusIndicators.rsaStatusflag &&
        statusIndicators.eBillOverAllStatus == true;

    const columns = [
        {
            dataIndex: 'name',
            width: '20%',
            render: (value: any) => <b>{value}</b>,
        },
        {
            dataIndex: 'value',
            width: '70%',
        },
        {
            title: <>Status {overallStatus ? <FaThumbsUp/> : <FaThumbsDown/>}</>,
            dataIndex: 'icon',
            width: '10%',
            align: 'center',
        },
    ];

    const items = [
        {
            name: 'BOT Run Status',
            value: statusIndicators.botRunStatus,
            icon: renderStatusIcon(statusIndicators.botRunStatusflag),
        },
        {
            name: 'BOT Run Date & Time',
            value: statusIndicators.botRunDateTime,
        },
        {
            name: 'RSA Status',
            value: statusIndicators.rsaStatus,
            icon: renderStatusIcon(statusIndicators.rsaStatusflag),
        },
        {
            name: 'E-Bill Overall Status',
            value: statusIndicators.eBillOverAllStatus?.toString(),
            icon: renderStatusIcon(statusIndicators.eBillOverAllStatus ?? false),
        },
        {
            name: 'BOT Activity Log',
            value: <TextArea
                autoSize={{minRows: 2, maxRows: 6}}
                value={statusIndicators.botActivityLog ?? ''}/>
        },
    ];

    return (
        <Table
            size={'small'}
            pagination={false}
            // @ts-ignore
            columns={columns}
            dataSource={items}/>
    );
};